import React, { useState, useEffect, useRef } from "react";
import './timer.css'
import { BsChevronUp } from "react-icons/bs";
import { BsChevronDown } from "react-icons/bs";
// import { customTheme as theme } from "../../../theme/customTheme";
import useCustomTheme from "../../../theme/useCustomTheme";

const Timer = (props) => {
  const listRef = useRef(null);
  const [theme ] = useCustomTheme()
  const { circularTime, finalTime, setFinalTime, numIntervals = 5, selectedColor, handleClose, finalDate, setFinalValue , extendEditingDate, hideLast} = props;

  const isTimePast = (timeStr) => {
    if (!hideLast) return false;
    const todayStr = new Date().toDateString();
    if (finalDate.toDateString() !== todayStr) return false;
    const [time, period] = timeStr.split(' ');
    const [h, m] = time.split(':').map(Number);
    let hours = h;
    if (period === 'PM' && h !== 12) hours += 12;
    if (period === 'AM' && h === 12) hours = 0;
    const timeMinutes = hours * 60 + parseInt(m);
    const now = new Date();
    return timeMinutes < now.getHours() * 60 + now.getMinutes();
  };
  const temparayTimeArr = [...circularTime]
  const [primaryColor, setPrimaryColor] = useState(`${theme.palette.primary.main}99`);
  const [primaryColorLight, setPrimaryColorLight] = useState(`${theme.palette.primary.main}70`);
  const [selectedTime, setSelectedTime] = useState(()=>{
    if( circularTime.includes(finalTime))
    {
      return finalTime
    }
    else {
      return "00:00 AM"
    }
  })
  const [currentIndex, setCurrentIndex] = useState(() => {
    const selectedIndex = circularTime.indexOf(selectedTime);
    return selectedIndex === -1 ? 0 : selectedIndex;
  });

  // const setValues = (time) => {
  //   // let dateString = `${finalValue.toDateString()}, ${time}`

  //   setSelectedTime(time);
  //   setFinalTime(time);
  //   // setFinalValue(new Date(Date.parse(dateString)))
  // }
  const setValues = (time) => {
    // let dateString = `${finalValue.toDateString()}, ${time}`
    setSelectedTime(time);
    let tempValue = new Date(Date.parse(`${finalDate.toDateString()}, ${time}`))
    setFinalTime(time);
    setFinalValue(tempValue.toLocaleString('en-US', {weekday: 'short', day: "2-digit", month: "2-digit", year: "numeric", hour: 'numeric', hour12: true, minute:'numeric'}))
    // setFinalValue(new Date(Date.parse(dateString)))
  }

  useEffect(() => {
    const selectedIndex = circularTime.indexOf(selectedTime);
    if (selectedIndex !== -1) {
      setCurrentIndex(selectedIndex);
    }
    else{
      setCurrentIndex(0);
    }
  }, [selectedTime, circularTime]);

  // When today is selected and the current time slot is in the past, jump to the first available future slot
  useEffect(() => {
    if (!hideLast) return;
    if (finalDate.toDateString() !== new Date().toDateString()) return;
    const firstAvailableIndex = circularTime.findIndex(t => !isTimePast(t));
    if (firstAvailableIndex === -1) return;
    if (isTimePast(selectedTime) || !circularTime.includes(selectedTime)) {
      setCurrentIndex(firstAvailableIndex);
      setValues(circularTime[firstAvailableIndex]);
    }
  }, [finalDate]);

  const downScroll = () => {
    let nextIndex = currentIndex === circularTime.length - 1 ? 0 : currentIndex + 1;
    while (isTimePast(circularTime[nextIndex]) && nextIndex !== currentIndex) {
      nextIndex = nextIndex === circularTime.length - 1 ? 0 : nextIndex + 1;
    }
    setCurrentIndex(nextIndex);
    setValues(circularTime[nextIndex]);
  };

  const upScroll = () => {
    let prevIndex = currentIndex === 0 ? circularTime.length - 1 : currentIndex - 1;
    if (isTimePast(circularTime[prevIndex])) return;
    setCurrentIndex(prevIndex);
    setValues(circularTime[prevIndex]);
  };

  const handleTimeSelection = (selectedTime) => {

    let tempValue = new Date(Date.parse(`${finalDate.toDateString()}, ${selectedTime}`))

    setValues(selectedTime);
    setFinalValue(tempValue.toLocaleString('en-US', {weekday: 'short', day: "2-digit", month: "2-digit", year: "numeric", hour: 'numeric', hour12: true, minute:'numeric'}))
    // handleClose(false)

    if(extendEditingDate != true){
      handleClose(false)

    }
  };

  const handleScroll = (event) => {
    const direction = Math.sign(event.deltaY);
    const idx = circularTime.indexOf(selectedTime) === -1 ? 0 : circularTime.indexOf(selectedTime);
    const nextIndex = (idx + direction + circularTime.length) % circularTime.length;
    if (!isTimePast(circularTime[nextIndex])) {
      setValues(circularTime[nextIndex]);
    }
  };

  useEffect(() => {
    const el = listRef.current;
    if (!el) return;
    const onWheel = (e) => {
      e.preventDefault();
      e.stopPropagation();
      const direction = Math.sign(e.deltaY);
      const idx = circularTime.indexOf(selectedTime) === -1 ? 0 : circularTime.indexOf(selectedTime);
      const nextIndex = (idx + direction + circularTime.length) % circularTime.length;
      if (!isTimePast(circularTime[nextIndex])) {
        setValues(circularTime[nextIndex]);
      }
    };
    el.addEventListener('wheel', onWheel, { passive: false });
    return () => el.removeEventListener('wheel', onWheel);
  }, [selectedTime, circularTime, finalDate, hideLast]);

  if (currentIndex + numIntervals > circularTime.length) {
    const remaining = currentIndex + numIntervals - circularTime.length;
    temparayTimeArr.push(...circularTime.slice(0, remaining));
  }

  return (
    <div className="timer"  style={{'--primary-color': primaryColor, '--primary-light': primaryColorLight}}>
        <div className="up-icon" >
          <button className="button" onClick={upScroll}><BsChevronUp />
          </button>
        </div>
        <div className="list" ref={listRef}>
        {temparayTimeArr.slice(currentIndex, currentIndex + 5).map((time, i) => {
            const past = isTimePast(time);
            return (
              <p key={`${circularTime.indexOf(time) === currentIndex ? "selected" : "nonSelected"}_${time}`}
                onClick={past ? undefined : () => handleTimeSelection(time)}
                className={`${circularTime.indexOf(time) === currentIndex ? "selected time-list" : "time-list"} ${past ? "past-time" : ""}`}
                style={{ backgroundColor: circularTime.indexOf(time) === currentIndex ? selectedColor : "" }}
              >{time}</p>
            );
          })}
        </div>
        <div className="down-icon">
          <button className="button" onClick={downScroll}><BsChevronDown />
          </button>
        </div>
      
    </div>
  );
};

export default Timer;